import React from "react";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      className="relative pt-12 pb-10 border-t border-black/10"
      data-testid="site-footer"
    >
      <div className="max-w-6xl mx-auto px-6 md:px-12 grid grid-cols-1 md:grid-cols-12 gap-8">
        <div className="md:col-span-5">
          <p
            className="text-lg font-semibold text-[#1a1a1a]"
            style={{ fontFamily: "Rubik, sans-serif" }}
          >
            Pull the Thread
          </p>
          <p className="text-sm text-[#3a3a3a]/75 mt-2 max-w-md leading-relaxed">
            A small daily ritual inside The Weave's 1% Club. Four threads on
            the loom; one pull, one card; a moment that earns its place in
            your day.
          </p>
        </div>

        <div className="md:col-span-3">
          <p className="text-xs uppercase tracking-[0.18em] text-[#3a3a3a]/55 mb-3">
            Sister pages
          </p>
          <ul className="space-y-2 text-sm text-[#1a1a1a]">
            <li>
              <a
                href="https://wearetheweave.co.uk"
                target="_blank"
                rel="noopener noreferrer"
                className="weave-link"
                data-testid="footer-link-main"
              >
                wearetheweave.co.uk
              </a>
            </li>
            <li>
              <a
                href="https://catch.wearetheweave.co.uk"
                target="_blank"
                rel="noopener noreferrer"
                className="weave-link"
                data-testid="footer-link-catch"
              >
                Catch the Wave
              </a>
            </li>
            <li>
              <a
                href="https://funding-hub.wearetheweave.co.uk"
                target="_blank"
                rel="noopener noreferrer"
                className="weave-link"
                data-testid="footer-link-funding"
              >
                Funding Hub
              </a>
            </li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <p className="text-xs uppercase tracking-[0.18em] text-[#3a3a3a]/55 mb-3">
            On the loom
          </p>
          <ul className="space-y-2 text-sm text-[#1a1a1a]">
            <li>
              <a href="#yarns" className="weave-link" data-testid="footer-nav-yarns">
                The four yarns
              </a>
            </li>
            <li>
              <a href="#sandrine" className="weave-link" data-testid="footer-nav-sandrine">
                Sandrine, Head of Community Wellbeing
              </a>
            </li>
            <li>
              <a href="#saved" className="weave-link" data-testid="footer-nav-saved">
                Your loomboard
              </a>
            </li>
            <li>
              <a
                href="https://www.wearetheweave.co.uk/blog"
                target="_blank"
                rel="noopener noreferrer"
                className="weave-link"
                data-testid="footer-nav-blog"
              >
                The Weave blog
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="max-w-6xl mx-auto px-6 md:px-12 mt-12 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
        <p className="text-xs text-[#3a3a3a]/65">
          © {year} Relocon t/a The Weave Limited. Pull the Thread is part of
          the 1% Club's Entertainment quadrant.
        </p>
        <p
          className="text-xs text-[#3a3a3a]/65 flex items-center gap-2"
          data-testid="emergent-credit"
        >
          <span
            className="inline-block w-1.5 h-1.5 rounded-full"
            style={{ backgroundColor: "#2596be" }}
            aria-hidden
          />
          Made with{" "}
          <a
            href="https://emergent.sh"
            target="_blank"
            rel="noopener noreferrer"
            className="weave-link font-medium"
          >
            Emergent
          </a>
        </p>
      </div>
    </footer>
  );
}
